require('./InputIban.scss');
require('./InputIban.override.scss');
const PropTypes = require('prop-types');
const React = require('react');
const {
    Component
} = require('react');
const classNames = require('classnames');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const formHelper = require('../../utilities/formHelper');

class InputIban extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.value || ['', ['', '', '', '', '', '']]
        };

        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
    }

    handleOnBlur(event) {
        const inputValue = event.target.value;
        const id = event.target.id;
        const i = id.substr(id.length - 1);
        let value = this.state.value;
        value[1][i] = inputValue;

        this.props.dataReceiver(value);

        this.setState({ value });
    }

    handleOnChange(val) {
        let value = this.state.value;
        if (formHelper.stringToBoolean(val) !== value[0]) {
            value[1] = [];
            for (let i = 0; i < 6; i++) {
                value[1][i] = '';
            }
        }
        value[0] = formHelper.stringToBoolean(val);
        this.props.dataReceiver(value);

        this.setState({ value });
    }

    renderIbanInputs(id) {
        const disabled = !this.state.value[0];
        let ibanInputs = [];

        for (let index = 0; index < 6; index++) {
            ibanInputs.push(
                <input
                    className="ok-input__input ok-input__input--iban input-iban__inputs__input"
                    disabled={disabled}
                    maxLength="4"
                    value={this.state.value[1][index].trim().toUpperCase()}
                    id={`iban_${id}_${index}`}
                    onBlur={this.handleOnBlur}
                    onChange={this.handleOnBlur}
                />
            );
        }

        return ibanInputs;
    }

    render() {
        const {
            label,
            labelYes,
            labelNo,
            errorState,
            errorMessageRequiredIbanValue,
            errorMessageRequiredIbanOption,
            errorMessageRequiredIbanNotValid,
            id
        } = this.props;
        const [ selectedValue, inputsValue ] = this.state.value;
        let labelElement, messageElement, messageElementIban;
        const error = errorState.toJS ? errorState.toJS() : errorState;
        const message = error[0] ? errorMessageRequiredIbanOption : '';
        const messageIban = error[1] &&
            (inputsValue.every(value => value === '') ? errorMessageRequiredIbanValue : errorMessageRequiredIbanNotValid);
        const inputClassName = classNames(
            'ok-input input-iban',
            {
                'ok-input--error': error[1]
            }
        );
        const ibanInputs = this.renderIbanInputs(id);

        const labelId = `lbl_${id}`;
        const messageId = `text_${id}`;

        if (label) {
            labelElement = (
                <p id={labelId} className="input-iban__label">
                    {label}
                </p>
            );
        }

        if (message) {
            messageElement = (
                <span id={messageId} className="ok-input__message">
                    {message}
                </span>
            );
        }

        if (messageIban) {
            messageElementIban = (
                <span id={messageId + '_iban'} className="ok-input__message">
                    {messageIban}
                </span>
            );
        }

        return (
            <div className={inputClassName}>
                {labelElement}
                <RadioButtonGroup
                    name={id + '1'}
                    idPrefix={id + '1'}
                    key={id + '1'}
                    selectedValue={selectedValue}
                    className="block-step__radio-group"
                    onChange={this.handleOnChange}
                >
                    <RadioButton
                        label={labelYes}
                        value={true}
                        key={id + '1'}
                        className="block-step__radio"
                    />
                </RadioButtonGroup>

                <div className="input-iban__inputs">
                    {ibanInputs}
                    <span>{messageElementIban}</span>
                </div>

                <RadioButtonGroup
                    name={id + '0'}
                    idPrefix={id + '0'}
                    key={id + '0'}
                    selectedValue={selectedValue}
                    className="block-step__radio-group"
                    onChange={this.handleOnChange}
                >
                    <RadioButton
                        label={labelNo}
                        value={false}
                        key={id + '0'}
                        className="block-step__radio"
                    />
                </RadioButtonGroup>
                {messageElement}
            </div>
        );
    }
}

InputIban.defaultProps = {
    id: 'iban',
    label: '',
    labelYes: '',
    labelNo: '',
    errorState: false,
    errorMessageRequiredIbanValue: ''
};

InputIban.propTypes = {
    dataReceiver: PropTypes.func,
    value: PropTypes.any.isRequired,
    id: PropTypes.any.isRequired,
    label: PropTypes.any.isRequired,
    labelYes: PropTypes.any.isRequired,
    labelNo: PropTypes.any.isRequired,
    errorState: PropTypes.any.isRequired,
    errorMessageRequiredIbanOption: PropTypes.any.isRequired,
    errorMessageRequiredIbanValue: PropTypes.any.isRequired,
    errorMessageRequiredIbanNotValid: PropTypes.string
};

module.exports = InputIban;